import React, { useEffect, useState } from 'react';
import DesktopNews from './newsModule/DesktopNews.tsx';
import MobileNews from './newsModule/MobileNews.tsx';
import { useNewsData } from './newsModule/useNewsData.ts';

const News: React.FC = () => {
    const [isMd, setIsMd] = useState(window.matchMedia('(min-width: 67.5rem)').matches);
    const { newsItems, CV } = useNewsData();

    useEffect(() => {
        const mediaQuery = window.matchMedia('(min-width: 67.5rem)');
        const updateIsMd = () => {
            setIsMd(mediaQuery.matches);
        };

        mediaQuery.addListener(updateIsMd);
        return () => {
            mediaQuery.removeListener(updateIsMd);
        };
    }, []);

    const BulletCommon = "before:content-[''] before:absolute before:left-0 before:top-2 before:w-3 before:h-3 before:rounded-full before:border-2 before:border-textGrey";

    return (
        <div className='flex flex-col items-center'>
            <br />
            <p className='text-textGrey font-condensed text-center font-extrabold text-2xl' id='news'>
                NEWS!
            </p>
            {isMd ? (
                <DesktopNews newsItems={newsItems} bulletStyle={BulletCommon} cvLink={CV} />
            ) : (
                <MobileNews newsItems={newsItems} bulletStyle={BulletCommon} cvLink={CV} />
            )}
            <br />
        </div>
    );
};

export default News;